import { apiCall } from "./auth";
import { API_URL } from "./config";


/**
 * Function to fetch prescription data from the API.
 *
 * @param {Object} data - The data to be sent in the request body.
 * @return {Promise} A promise that resolves to the response data.
 */
export const getPrescription = (data) => {
  // Define the endpoint URL and the HTTP method.
  const url = `${API_URL}prescription/getPrescription`;
  const method = "POST";

  // Make the API call with the defined endpoint, method, and data.
  return apiCall(url, method, data);
};
export const addPrescription = (data) => apiCall(`${API_URL}prescription/addPrescription`, "POST", data);
export const deleteProjectApi = (data) => apiCall(`${API_URL}prescription/deleteProject`, "POST",  data);
export const upatePrescription = (data) => apiCall(`${API_URL}prescription/upatePrescription`, "POST",  data);
export const getallPrescription = () => apiCall(`${API_URL}prescription/getallPrescription`, "GET");
export const upatePrescriptionStatus = (data) => apiCall(`${API_URL}prescription/upatePrescriptionStatus`, "POST",data);
export const proscriptionhistory = (data) => apiCall(`${API_URL}prescription/proscriptionhistory`, "POST",data);
export const getuserPrescription = (data) => apiCall(`${API_URL}prescription/getuserPrescription`, "POST",data);


//Notes
export const addnotes = (data) => apiCall(`${API_URL}prescription/addnotes`, "POST",data);
export const getnotes = (data) => apiCall(`${API_URL}prescription/getnotes`, "POST",data);
export const getnotesuser = (data) => apiCall(`${API_URL}prescription/getnotesuser`, "POST",data);
export const addclubfittingdata = (data) => apiCall(`${API_URL}remotefittinginquires/addclubfittingdata`, "POST",data);
export const upatedeliverytype = (data) => apiCall(`${API_URL}remotefittinginquires/upatedeliverytype`, "POST",data);

export const getwebhookdata = (data) => apiCall(`${API_URL}remotefittinginquires/getwebhookdata`, "POST",data);